import React from 'react'
import { NavLink, useNavigate } from 'react-router-dom'
import { useAuth } from '../hooks/useAuth'

function Icon({ name }) {
  const props = { width: 16, height: 16, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: 2, strokeLinecap: 'round', strokeLinejoin: 'round', 'aria-hidden': true }
  switch (name) {
    case 'plus': return <svg {...props}><path d="M12 5v14M5 12h14"/></svg>
    case 'list': return <svg {...props}><path d="M8 6h13M8 12h13M8 18h13M3 6h.01M3 12h.01M3 18h.01"/></svg>
    case 'doc': return <svg {...props}><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><path d="M14 2v6h6M9 13h6M9 17h6"/></svg>
    case 'user': return <svg {...props}><circle cx="12" cy="8" r="4"/><path d="M4 21a8 8 0 0 1 16 0"/></svg>
    case 'building': return <svg {...props}><rect x="4" y="3" width="16" height="18" rx="1"/><path d="M9 7h.01M15 7h.01M9 11h.01M15 11h.01M9 15h.01M15 15h.01"/></svg>
    case 'gear': return <svg {...props}><circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.7 1.7 0 0 0 .3 1.8l.1.1a2 2 0 1 1-2.8 2.8l-.1-.1a1.7 1.7 0 0 0-1.8-.3 1.7 1.7 0 0 0-1 1.5V21a2 2 0 1 1-4 0v-.1a1.7 1.7 0 0 0-1.1-1.5 1.7 1.7 0 0 0-1.8.3l-.1.1a2 2 0 1 1-2.8-2.8l.1-.1a1.7 1.7 0 0 0 .3-1.8 1.7 1.7 0 0 0-1.5-1H3a2 2 0 1 1 0-4h.1a1.7 1.7 0 0 0 1.5-1.1 1.7 1.7 0 0 0-.3-1.8l-.1-.1a2 2 0 1 1 2.8-2.8l.1.1a1.7 1.7 0 0 0 1.8.3H9a1.7 1.7 0 0 0 1-1.5V3a2 2 0 1 1 4 0v.1a1.7 1.7 0 0 0 1 1.5 1.7 1.7 0 0 0 1.8-.3l.1-.1a2 2 0 1 1 2.8 2.8l-.1.1a1.7 1.7 0 0 0-.3 1.8V9a1.7 1.7 0 0 0 1.5 1H21a2 2 0 1 1 0 4h-.1a1.7 1.7 0 0 0-1.5 1z"/></svg>
    case 'sliders': return <svg {...props}><path d="M4 21v-7M4 10V3M12 21v-9M12 8V3M20 21v-5M20 12V3M1 14h6M9 8h6M17 16h6"/></svg>
    case 'shield': return <svg {...props}><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>
    case 'mail': return <svg {...props}><rect x="3" y="5" width="18" height="14" rx="2"/><path d="m3 7 9 6 9-6"/></svg>
    case 'logout': return <svg {...props}><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4M16 17l5-5-5-5M21 12H9"/></svg>
    case 'lock': return <svg {...props}><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>
    default: return null
  }
}

export default function Layout({ children }) {
  const { profile, signOut } = useAuth()
  const navigate = useNavigate()

  async function handleSignOut() {
    await signOut()
    navigate('/login')
  }

  const isAdmin = profile?.ruolo === 'admin'

  return (
    <div className="layout">
      <aside className="sidebar">
        <div className="sidebar-logo">
          <img src="/logo-diemmeci.png" alt="Diemmeci Broker" className="brand-logo" />
        </div>
        <div className="logo-role-bar">
          <span>{isAdmin ? 'Amministratore' : (profile?.ruolo === 'subagente' ? 'Subagente' : 'Dealer')}</span>
        </div>
        <div className="road-strip" aria-hidden="true"><span /></div>

        <ul className="sidebar-nav">
          <li>
            <NavLink to="/pratiche/nuova" className={({ isActive }) => isActive ? 'active' : ''}>
              <span className="nav-icon"><Icon name="plus" /></span> Nuova pratica
            </NavLink>
          </li>
          <li>
            <NavLink to="/pratiche" className={({ isActive }) => isActive ? 'active' : ''} end>
              <span className="nav-icon"><Icon name="list" /></span> Pratiche aperte
            </NavLink>
          </li>
          <li>
            <NavLink to="/documentale" className={({ isActive }) => isActive ? 'active' : ''}>
              <span className="nav-icon"><Icon name="doc" /></span> Documentale
            </NavLink>
          </li>
          <li>
            <NavLink to="/calcolatore-finanziamento" className={({ isActive }) => isActive ? 'active' : ''}>
              <span className="nav-icon"><Icon name="sliders" /></span> Calcolatore finanziamento
            </NavLink>
          </li>
          <li>
            <a href="https://ics.xconsulting.it/home" target="_blank" rel="noopener noreferrer">
              <span className="nav-icon"><Icon name="lock" /></span> Privacy
            </a>
          </li>

          {isAdmin && (
            <>
              <li className="nav-section">Anagrafica</li>
              <li><NavLink to="/admin/utenti" className={({ isActive }) => isActive ? 'active' : ''}><span className="nav-icon"><Icon name="user" /></span> Utenti</NavLink></li>
              <li><NavLink to="/admin/compagnie" className={({ isActive }) => isActive ? 'active' : ''}><span className="nav-icon"><Icon name="building" /></span> Compagnie</NavLink></li>

              <li className="nav-section">Tariffe</li>
              <li><NavLink to="/admin/tariffe" className={({ isActive }) => isActive ? 'active' : ''}><span className="nav-icon"><Icon name="gear" /></span> Tassi e zone</NavLink></li>
              <li><NavLink to="/admin/parametri" className={({ isActive }) => isActive ? 'active' : ''}><span className="nav-icon"><Icon name="sliders" /></span> Parametri</NavLink></li>

              <li className="nav-section">Altro</li>
              <li><NavLink to="/admin/standalone" className={({ isActive }) => isActive ? 'active' : ''}><span className="nav-icon"><Icon name="shield" /></span> Stand alone</NavLink></li>
              <li><NavLink to="/admin/email" className={({ isActive }) => isActive ? 'active' : ''}><span className="nav-icon"><Icon name="mail" /></span> Email</NavLink></li>
            </>
          )}
        </ul>

        <div className="sidebar-bottom">
          <div className="sidebar-user">
            <div className="su-avatar">{(profile?.nome?.[0] || '?').toUpperCase()}{(profile?.cognome?.[0] || '').toUpperCase()}</div>
            <div className="su-info">
              <strong title={`${profile?.nome || ''} ${profile?.cognome || ''}`}>{profile?.nome} {profile?.cognome}</strong>
              <span className="su-email" title={profile?.email}>{profile?.email}</span>
            </div>
          </div>
          <button className="btn btn-sm btn-logout" onClick={handleSignOut}>
            <Icon name="logout" /> Esci
          </button>
        </div>
      </aside>

      <main className="main">
        <div className="main-content">{children}</div>
        <footer className="app-footer" style={{
          position: 'sticky', bottom: 0, zIndex: 2,
          padding: '12px 24px', textAlign: 'center', fontSize: 12,
          color: 'var(--text-muted)', borderTop: '1px solid var(--border)',
          background: 'var(--purple-soft)',
          boxShadow: '0 -4px 12px -8px rgba(0,0,0,0.25)',
        }}>
          Partita IVA 04034751208 - Iscrizione RUI B000714654 - Società soggetta alla vigilanza Ivass
        </footer>
      </main>
    </div>
  )
}
